import { AccordionDetails, Divider, IconButton, List, ListItem, ListItemText } from '@mui/material';
import { GridDeleteIcon } from '@mui/x-data-grid';

const TitleComponent: React.FC<any> = ({ hosts, removeHost }: any) => {
    return (
        <AccordionDetails>
            <div style={{ width: '100%', maxHeight: '200px', overflowY: 'scroll' }}>
                <List sx={{ width: '100%' }}>
                    {hosts.map((value: any) => (
                        <div key={value}>
                            <ListItem
                                disableGutters
                                secondaryAction={
                                    <IconButton
                                        aria-label="delete"
                                        onClick={() => removeHost(value)}
                                    >
                                        <GridDeleteIcon />
                                    </IconButton>
                                }
                            >
                                <ListItemText primary={value} />
                            </ListItem>
                            <Divider />
                        </div>
                    ))}
                </List>
            </div>
        </AccordionDetails>
    );
};

export default TitleComponent;
